/**
 * @generated SignedSource<<23d6dce53675be3caa3abbce9ee6401d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RequestAccessQuery$variables = {
  guid: string;
  streamId: string;
};
export type RequestAccessQuery$data = {
  readonly restrictedNoteStream: {
    readonly id: string;
    readonly urlForViewer: string | null;
    readonly userWithAccess: {
      readonly email: string;
      readonly fullName: string;
      readonly id: string;
      readonly internalAttributes: {
        readonly slackDmLink: string | null;
        readonly teamsDmLink: string | null;
      } | null;
      readonly isActive: boolean;
    } | null;
  } | null;
};
export type RequestAccessQuery = {
  response: RequestAccessQuery$data;
  variables: RequestAccessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "guid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "guid",
    "variableName": "guid"
  },
  {
    "kind": "Variable",
    "name": "streamId",
    "variableName": "streamId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlForViewer",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackDmLink",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamsDmLink",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RequestAccessQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RestrictedNoteStream",
        "kind": "LinkedField",
        "name": "restrictedNoteStream",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "userWithAccess",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RequestAccessQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RestrictedNoteStream",
        "kind": "LinkedField",
        "name": "restrictedNoteStream",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "userWithAccess",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1244fc3efac053b46efb3c6279f45eac",
    "id": null,
    "metadata": {},
    "name": "RequestAccessQuery",
    "operationKind": "query",
    "text": "query RequestAccessQuery(\n  $guid: String!\n  $streamId: ID!\n) {\n  restrictedNoteStream(guid: $guid, streamId: $streamId) {\n    id\n    urlForViewer\n    userWithAccess {\n      id\n      email\n      fullName\n      isActive\n      internalAttributes {\n        slackDmLink\n        teamsDmLink\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a0096af56b7fca1dc9b3fcfa8402e51c";

export default node;
